<script>
export default {
    name: "RCDCollectionList",
    props: {
        rcd: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },
    methods: {
    }
}
</script>
<template>
    <b-collapse
        :visible="rcd.collectionShow"
        :accordion="`rcd-list-accordion-${type}-${rcd.id}`"
        role="tabpanel"
    >
        <div v-if="rcd.rcdDetails && rcd.rcdDetails.length" class="mt-3">
            <table class="table table-sm table-bordered">
                <thead class="table-light">
                    <tr>
                        <th>OR Number</th>
                        <th>Description</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="collection in rcd.rcdDetails" :key="collection.id">
                        <td>{{ collection.orNumber }}</td>
                        <td>{{ collection.collection || '-' }}</td>
                        <td class="text-end">
                            {{formatCurrency(collection.totalAmount || 0)}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </b-collapse>
</template>